// 隐藏命令面板中的分享、实时协作和PWA安装命令项
(function () {
  // 创建一个函数来处理命令项
  function hideShareCollabPwaCommands() {
    // 查找所有命令项
    const commandItems = document.querySelectorAll(
      ".command-palette-dialog .command-category .command-item",
    );

    // 要隐藏的关键词列表
    const keywordsToHide = [
      "分享",
      "share",
      "实时协作",
      "collaboration",
      "live",
      "PWA",
      "Install",
      "安装",
    ];

    // 遍历所有命令项
    commandItems.forEach((item) => {
      // 获取name元素的文本内容（更精确）
      const nameElement = item.querySelector(".name");
      if (!nameElement) {
        return;
      }

      const nameText = nameElement.textContent || "";

      // 检查是否包含任何要隐藏的关键词
      const shouldHide = keywordsToHide.some((keyword) =>
        nameText.toLowerCase().includes(keyword.toLowerCase()),
      );

      if (shouldHide) {
        item.style.display = "none";
      }
    });
  }

  // 在DOM加载完成后执行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObserver);
  } else {
    initObserver();
  }

  // 初始化观察器
  function initObserver() {
    // 创建一个观察器来监视DOM变化
    const observer = new MutationObserver((mutations) => {
      // 检查是否有命令面板对话框
      const commandPaletteDialog = document.querySelector(
        ".command-palette-dialog",
      );
      if (commandPaletteDialog) {
        // 如果命令面板对话框存在，执行隐藏操作
        hideShareCollabPwaCommands();
      }
    });

    // 开始观察文档变化
    observer.observe(document.body, { childList: true, subtree: true });

    // 立即执行一次隐藏操作
    hideShareCollabPwaCommands();
  }
})();
